import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=ebb7ae34&scoped=true"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=ebb7ae34&prod&lang=scss&scoped=true"
import style1 from "./RegisterUser.vue?vue&type=style&index=1&id=ebb7ae34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb7ae34",
  null
  
)

export default component.exports